import {
  Card,
  CardContent,
  CardHeader,
} from "@/components/ui/card"
import {
  Field,
  FieldDescription,
  FieldLabel,
} from "@/components/ui/field"

const RedirectView = () => {
  return (
    <div className='flex flex-col justify-center my-auto min-h-screen'>
    <Card className='sm:max-w-sm w-full mx-auto sm:min-h-min min-h-screen sm:rounded-xl rounded-none'>        
      <CardHeader>
        <div className="flex justify-between">
          <div className="mx-auto">
            <img
              className="dark:hidden h-12 text-center block"
              src={"/images/black-logo.png"}
              alt="Collectr"
            />
            <img
              className="hidden h-12 text-center dark:block"
              src={"/images/white-logo.png"}
              alt="Collectr"
            />
          </div>
        </div>
      </CardHeader>
      <CardContent>
        <div className="mt-4 flex flex-col justify-center">
            <Field className='flex flex-col items-center justify-center'>
                <FieldLabel htmlFor='code' className='text-3xl flex flex-col items-center justify-center'>
                    Redirecting...
                </FieldLabel>
                <FieldDescription className='text-center'>
                    Please wait while we redirect you, this will take a few seconds. Don't close this page.
                </FieldDescription>

                <img    
                  className="w-25! h-auto! mx-auto pt-7"
                  src={"/images/running-pikachu.gif"}
                  alt="Loading"
                />
            </Field>
        </div>
      </CardContent>
    </Card>
  </div>
  )
}

export default RedirectView;    